import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { Loader } from "@circle-react-uikit/Loader";
import type { DateRange } from "../hooks/useDateRanges";

interface DateRangeDropdownProps {
  dateRanges: DateRange[];
  isLoading: boolean;
  onDateRangeSelect: (range: DateRange) => void;
  onDropdownClick: () => void;
}

export const DateRangeDropdown = ({
  dateRanges,
  isLoading,
  onDropdownClick,
  onDateRangeSelect,
}: DateRangeDropdownProps) => (
  <Dropdown
    direction="bottom-start"
    size="large"
    onToggle={isOpen => {
      if (isOpen) {
        onDropdownClick();
      }
    }}
    button={
      <Dropdown.MenuButton className="!border-0 !bg-transparent !p-0">
        <Button variant="text" className="!p-0">
          <span className="inline-flex items-center gap-0">
            {t("settings.billing.ai_actions.view_usage_history")}
            <Icon type="caret-down-bold" size={12} className="mb-1 shrink-0" />
          </span>
        </Button>
      </Dropdown.MenuButton>
    }
  >
    <div className="py-1">
      {isLoading ? (
        <div className="flex items-center justify-center px-4 py-8">
          <Loader className="size-5" />
        </div>
      ) : dateRanges.length === 0 ? (
        <div className="px-4 py-2 text-sm text-gray-500">
          {t("settings.billing.ai_actions.no_billing_cycles", {
            defaultValue: "No billing cycles found",
          })}
        </div>
      ) : (
        dateRanges.map(range => (
          <Dropdown.Item key={range.value}>
            <button
              type="button"
              onClick={() => onDateRangeSelect(range)}
              className="text-dark hover:bg-secondary w-full px-4 py-2 text-left text-sm transition-colors"
            >
              {range.label}
            </button>
          </Dropdown.Item>
        ))
      )}
    </div>
  </Dropdown>
);
